import { render } from "./setup.vue?vue&type=template&id=411fc214&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import "./setup.vue?vue&type=style&index=0&id=411fc214&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411fc214"]])

export default __exports__